import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { CartaoDeArquivo } from './CartaoDeArquivo.js';
import { TocadorAudio } from './TocadorAudio';
import { VisualizadorMidia } from './VisualizadorMidia';
/**
 * A bolha de um anexo, igual nos dois chats.
 *
 * Decide pelo mimeType, não pelo tipo da mensagem: vídeo é gravado como `arquivo` no
 * banco (o enum não tem esse valor) e só o mimeType distingue um mp4 de um PDF.
 *
 * As URLs são assinadas e de vida curta. Se o cliente deixar a aba aberta por horas, a
 * mídia pára de carregar até a próxima busca de mensagens — é o comportamento desejado.
 */
export function Anexo({ url, nomeOriginal, mimeType, tamanho, previaUrl, perguntarOndeSalvar, }) {
    const [ampliado, setAmpliado] = useState(false);
    if (mimeType.startsWith('image/')) {
        return (_jsxs(_Fragment, { children: [_jsx("button", { type: "button", onClick: () => setAmpliado(true), className: "block", title: "Ampliar", children: _jsx("img", { src: url, alt: nomeOriginal, className: "mb-1 max-h-64 rounded-lg" }) }), ampliado && (_jsx(VisualizadorMidia, { url: url, nomeOriginal: nomeOriginal, mimeType: mimeType, perguntarOndeSalvar: perguntarOndeSalvar, aoFechar: () => setAmpliado(false) }))] }));
    }
    if (mimeType.startsWith('video/')) {
        return (_jsxs(_Fragment, { children: [_jsx("video", { src: url, controls: true, preload: "metadata", onClick: (e) => {
                        // Só o quadro abre o visualizador: clique nos controles é para o player.
                        if (e.target === e.currentTarget)
                            setAmpliado(true);
                    }, className: "mb-1 max-h-64 rounded-lg" }), ampliado && (_jsx(VisualizadorMidia, { url: url, nomeOriginal: nomeOriginal, mimeType: mimeType, perguntarOndeSalvar: perguntarOndeSalvar, aoFechar: () => setAmpliado(false) }))] }));
    }
    if (mimeType.startsWith('audio/')) {
        // Tocador próprio: o do navegador traz volume (inútil num recado de voz) e esconde a
        // barra de tempo em tela estreita, que é onde o áudio mais aparece.
        return _jsx(TocadorAudio, { url: url });
    }
    // Documento, planilha, apresentação, mapa, compactado: cartão com prévia e dois
    // caminhos separados. Era um link com o nome inteiro à mostra, e o nome inteiro de um
    // PDF do Drive tem setenta caracteres de base64 (visto em produção, 08/10).
    return (_jsx(CartaoDeArquivo, { url: url, nomeOriginal: nomeOriginal, mimeType: mimeType, tamanho: tamanho, previaUrl: previaUrl, perguntarOndeSalvar: perguntarOndeSalvar }));
}
//# sourceMappingURL=Anexo.js.map